/**
 * 删除对象中的空字符及null
 * @param obj 要处理的对象
 * @param parent
 * @param parentKey
 * @returns {*}
 */
export function removeEmpty(obj, parent, parentKey) {
  Object.keys(obj).forEach(key => {
    if (obj[key] && typeof obj[key] === 'object') {
      removeEmpty(obj[key], obj, key)
    }
    if (obj[key] === undefined || obj[key] === null || (obj[key] !== null && obj[key].length === 0) || obj[key] === '') {
      delete obj[key]
    }
  })
  if (Object.keys(obj).length === 0) {
    delete parent[parentKey]
  }
  return obj
}

export function formatNum(str) {
  let newStr = ''
  let count = 0
  // 判断是不是数值
  if (isNaN(str)) {
    // console.error('str is not Number')
    return
  }
  // 首先先将数值根据 ‘.’剪切成一个数组
  const arr = (str + '').split('.')
  // 判断数组的长度最长为2  0.00
  if (arr.length <= 1) {
    // 如果数组长度小于1 则进行拼接千分位逗号拼接小数点后两位
    for (var i = arr[0].length - 1; i >= 0; i--) {
      if (count % 3 === 0 && count !== 0) {
        newStr = arr[0].charAt(i) + ',' + newStr
      } else {
        newStr = arr[0].charAt(i) + newStr
      }
      count++
    }
    str = newStr + '.00' // 自动补小数点后两位
    return str
  } else {
    // 如果数组长度大于1 则先进行拼接千分位逗号再 拼接小数点后两位
    for (let i = arr[0].length - 1; i >= 0; i--) {
      if (count % 3 === 0 && count !== 0) {
        newStr = arr[0].charAt(i) + ',' + newStr
      } else {
        newStr = arr[0].charAt(i) + newStr
      }
      count++
    }
    str = newStr + (str + '00').substr((str + '00').indexOf('.'), 3)
    return str
  }
}

/**
 * 去除首位空格
 * 2019-11-19 16:43:16
 * @param str
 */
export function trim(str) {
  if (!str && str !== 0) return ''
  str += ''
  return str.replace(/(^\s*)|(\s*$)/g, '')
}
/**
 * 去除所有空格
 * 2019-11-19 16:43:16
 * @param str
 */
export function allTrim(str) {
  if (!str && str !== 0) return ''
  str += ''
  return str.replace(/\s*/g, '')
}
/**
 * 只允许输入数字
 * @author 王老玖
 */
export function allowNumber(str) {
  return str.replace(/[^\d]/g, '').replace(/^0{1,}/g, '')
}
/**
 * 只允许输入字母
 * @author 王老玖
 */
export function allowLetter(str) {
  return str.replace(/[^a-zA-Z]/g, '')
}

export function clearNoNum(obj) {
  obj.value = obj.value.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
  obj.value = obj.value.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
  obj.value = obj.value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
  obj.value = obj.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
  if (obj.value.indexOf('.') < 0 && obj.value !== '') { // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    obj.value = parseFloat(obj.value)
  }
}

/**
 * 禁输表情
 * @param value {String}
 */
export function inputEmoji(value) {
  var regStr
  regStr = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
  if (regStr.test(value)) {
    return value.replace(regStr, '')
  } else {
    return value
  }
}
/**
 * 序号递增函数
 * @author 王老玖
 */
export function indexMet(_Index) {
  if (this.listQuery.current) {
    return (_Index + 1) + (this.listQuery.current - 1) * this.listQuery.size
  } else return (_Index + 1) + (this.listQuery.p - 1) * this.listQuery.n
}

/**
 * 金额转换
 */
export function formatterPrice(cellVal) {
  if (cellVal === null || isNaN(cellVal)) return ''
  return '￥' + formatNum(cellVal)
}

export const formatTime = date => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()

  return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}

export const formatNumber = n => {
  n = n.toString()
  return n[1] ? n : '0' + n
}

/**
 * @return {null}
 */
export function GetQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}
/**
 * 节流
 * @param {*} func 执行函数
 * @param {*} delay 节流时间,毫秒
 */
export const throttle = function(func, delay) {
  let timer = null
  return function() {
    if (!timer) {
      timer = setTimeout(() => {
        func.apply(this, arguments)
        // 或者直接 func()
        timer = null
      }, delay)
    }
  }
}

/**
 * 防抖
 * @param {*} fn 执行函数
 * @param {*} wait 防抖时间,毫秒
 */
export const debounce = function(fn, wait) {
  let timeout = null
  return function() {
    if (timeout !== null) clearTimeout(timeout)// 如果多次触发将上次记录延迟清除掉
    timeout = setTimeout(() => {
      fn.apply(this, arguments)
      // 或者直接 fn()
      timeout = null
    }, wait)
  }
}

/**
 *  获取 url 后面通过?传参的参数
 * @param {String} name
 */
export function getQueryString(name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  const url = window.location.href
  const search = url.substring(url.lastIndexOf('?') + 1)
  const r = search.match(reg)
  if (r != null) return unescape(r[2])
  return null
}

export function onDownFile(url, filename) {
  const downUrl = url
  // 创建隐藏的可下载链接
  const eleLink = document.createElement('a')

  eleLink.download

  eleLink.style.display = 'none'
  // 字符内容转变成blob地址
  const blob = new window.Blob([downUrl])
  eleLink.href = URL.createObjectURL(blob)
  eleLink.target = `_blank`
  // 触发点击
  document.body.appendChild(eleLink)
  eleLink.click()
  // 然后移除
  document.body.removeChild(eleLink)
}

/**
 * 判断两个数组是否相等
 * 2020-5-18 09:39:51
 * @author SnowRock
 * @param array {Array} 数组一
 * @param other {Array} 数组二
 * @returns {boolean}
 */
export function arrayEqual(array, other) {
  const l = array.length
  if (!other) return false
  if (l !== other.length) return false

  for (let i = 0; i < l; i++) {
    if (array[i] instanceof Array && other[i] instanceof Array) {
      if (!array[i].equals(other[i])) return false
    } else if (array[i] !== other[i]) {
      return false
    }
  }
  return true
}
export function roundNumber(number, decimals) {
  var newString// The new rounded number
  decimals = Number(decimals)
  // 如果设置参数为0
  if (decimals === 0) {
    return (Math.round(number)).toString()
  }
  if (decimals < 1) {
    newString = (Math.round(number)).toString()
  } else {
    var numString = number.toString()
    if (numString.lastIndexOf('.') === -1) { // If there is no decimal point
      numString += '.'// give it one at the end
    }
    var cutoff = numString.lastIndexOf('.') + decimals // The point at which to truncate the number
    var d1 = Number(numString.substring(cutoff, cutoff + 1)) // The value of the last decimal place that we'll end up with
    var d2 = Number(numString.substring(cutoff + 1, cutoff + 2)) // The next decimal, after the last one we want
    if (d2 >= 5) { // Do we need to round up at all? If not, the string will just be truncated
      if (d1 === 9 && cutoff > 0) { // If the last digit is 9, find a new cutoff point
        while (cutoff > 0 && (d1 === 9 || isNaN(d1))) {
          if (d1 !== '.') {
            cutoff -= 1
            d1 = Number(numString.substring(cutoff, cutoff + 1))
          } else {
            cutoff -= 1
          }
        }
      }
      d1 += 1
    }
    if (d1 === 10) {
      numString = numString.substring(0, numString.lastIndexOf('.'))
      var roundedNum = Number(numString) + 1
      newString = roundedNum.toString() + '.'
    } else {
      newString = numString.substring(0, cutoff) + d1.toString()
    }
  }
  if (newString.lastIndexOf('.') === -1) { // Do this again, to the new string
    newString += '.'
  }
  var decs = (newString.substring(newString.lastIndexOf('.') + 1)).length
  for (var i = 0; i < decimals - decs; i++) newString += '0'
  return newString
}

/**
 * 数组去重
 * @param arr
 * @returns {any[]}
 */
export function unique(arr) {
  return Array.from(new Set(arr))
}

/**
 * 数组取异
 * @param arr
 * @param arrOther
 * @returns {any[]}
 */
export function uniqueDifferent(arr, arrOther) {
  return arr.filter(v => !arrOther.includes(v))
}

export function randomString(len) {
  len = len || 32
  // ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz
  // var $chars = 'abcdef0123456789';
  var $chars = '0123456789'
  /** 默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1 **/
  var maxPos = $chars.length
  var pwd = []
  for (let i = 0; i < len; i++) {
    pwd[i] = $chars[Math.floor(Math.random() * maxPos)]
  }
  return pwd.join('')
}

export function randomNum(minNum, maxNum) {
  switch (arguments.length) {
    case 1:
      return parseInt(Math.random() * minNum + 1, 10)
    case 2:
      return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10)
    default:
      return 0
  }
}

export function randomTimeStr() {
  const timeSign = new Date().getTime()
  const str = randomString(9)
  return 'SERVICE_PLATFORM_MANAGE:' + timeSign + ':' + str
}

export function randomTimeStrByMark() {
  const timeSign = new Date().getTime()
  const str = randomString(8)
  return timeSign + str
}

export function isPrice(value) {
  return /^([0-9]+)$/.test(value)
}

/**
 * 将数字转化为百分格式(保留2位小数点)
 * 2021-05-29 12:36:12
 * @author BM
 */
export function transformPercent(val) {
  if (typeof (val) === 'number') {
    return (val * 100).toFixed(2) + '%'
  }
}
/**
 * 将base64 的图片转换成file对象上传 atob将ascii码解析成binary数据
 * 2022-03-24 12:36:12
 * @author afeng
 */
export function base64ToFile(data) {
  const binary = atob(data.split(',')[1])
  const mime = data.split(',')[0].match(/:(.*?);/)[1]
  const array = []
  for (let i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i))
  }
  const fileData = new Blob([new Uint8Array(array)], {
    type: mime
  })

  const file = new File([fileData], `${new Date().getTime()}.png`, { type: mime })

  return file
}

export function isAdmin() {
  return sessionStorage.getItem('username') === 'admin'
}
